var SCM = SCM || {};

(function (ns, $) {

    function registerTablesorter() {
        $('.subscriptions-wrap table.tablesorter').tablesorter({
            theme: 'default',
            delayInit: true,
            ignoreCase: true,
            sortList: [[0, 0]]
        });
    }

    function registerLinkClick() {
        $('.js-subscription-resource-link').on('click', function () {
            var $this = $(this);
            var resourceId = $this.data('resource-id');
            var resourceType = $this.data('resource-type');
            
            if (parseInt(resourceId) > 0 && parseInt(resourceType) > 0) {
                $.get('/OUPMyAccount/GetResourceUrl',
                    {resourceId: resourceId, resourceType: resourceType},
                    function (resourceUrl) {
                        top.location = resourceUrl;
                    },
                    'text');
            }
        });
    }

    ns.initSubscriptions = function () {
        registerTablesorter();
        registerLinkClick();
    };
    
})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);
